<template>

<app-wrapper v-if="is.loaded">

	<app-wrapper class="listing-banner">

		<app-inner class="listing-banner-inner" :style="{backgroundImage: 'url(' + page.banner_image + ')'}">

			<h1>{{ page.banner_title}}</h1>

			<p>{{ page.banner_text }}</p>

			<app-group :row="true" :center="window.is.mobile">

				<app-button to="Login/Business" theme="white" :text="page.banner_button_login" />

			</app-group>

		</app-inner>

	</app-wrapper>

	<app-group class="plans">

		<stripe-pricing-table pricing-table-id="prctbl_1MZh7XJvQiizSfYDtLF08iMZ" publishable-key="pk_live_Jw0D1a1i7yGA8eJy4Wa9PXr6"></stripe-pricing-table>

	</app-group>

	<com-section v-for="(section, index) in page.sections" :index="index" :key="index" :item="section" :button="page.banner_button_join" />

	<div ref="sm"></div>

</app-wrapper>

</template>

<script>

import mixinPage from '@/mixin/page.js'

import comSection from './listing/Section'

export default {

	mixins: [mixinPage],

	components: {
		'com-section': comSection
	},

	computed: {

		loaded: function() {

			return this.is.loaded

		}

	},

	watch: {

		loaded: function() {

			/* if (n) {

				this.$nextTick(function() {

					var script = document.createElement('script')
					script.src = "https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgdyn9kSfjIGAOki20JTlQtsvWV_2BMIrru5wPhMTjVkE3pZ.js"
					this.$refs.sm.appendChild(script)

				}.bind(this))

			} */

		}

	}

}

</script>

<style scoped>

.plans {
	padding: 40px 0px;
}

.listing-banner {
	background-color: var(--color-grey-dark);
	padding: 64px 0px 96px 0px;
}

.is-mobile .listing-banner {
	padding: 20px 0px;
}

.listing-banner-inner {
	min-height: 300px!important;
	background-position: 100% 100%;
    background-size: 50% auto;
    background-repeat: no-repeat;
}

.is-mobile .listing-banner-inner {
	padding-bottom: 202px;
    background-size: 310px auto;
    background-position: 50% 100%;
}

.listing-banner h1 {
	color: #fff;
	width: 256px;
	padding-top: 48px;
    font-size: 64px;
	line-height: 60px;
    font-family: grueber,serif;
}

.is-mobile .listing-banner h1 {
	font-size: 32px;
	padding-top: 0px;
	line-height: 28px;
	text-align: center;
	width: 100%;
}

.listing-banner p {
	font-size: 32px;
	line-height: 36px;
	font-weight: 300;
    color: #fff;
    width: 50%;
    margin-bottom: 32px;
}

.is-mobile .listing-banner p {
	font-size: 18px;
	line-height: 22px;
	text-align: center;
	width: 100%;
}

</style>